import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { APP_VERSIONS, SUITE_VERSION } from '../../config/appVersions';
import { CHANGELOG_ENTRIES } from '../../config/changelogEntries';

const ChangelogPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Changelog
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        This suite is in <strong>alpha</strong> (version {SUITE_VERSION}). It is not intended for production
        design without independent verification. Per-tool versions below can be bumped independently as
        features mature.
      </Typography>

      <Paper sx={{ mt: 3, mb: 4, overflow: 'hidden' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Application</TableCell>
              <TableCell align="right">Version</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {APP_VERSIONS.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.name}</TableCell>
                <TableCell align="right">{row.version}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <Typography variant="h6" gutterBottom>
        Release notes
      </Typography>
      {CHANGELOG_ENTRIES.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No dated entries yet. Notable changes will be listed here after alpha {SUITE_VERSION}.
        </Typography>
      ) : (
        <Box component="ul" sx={{ pl: 2, m: 0 }}>
          {CHANGELOG_ENTRIES.map((entry, i) => (
            <Box component="li" key={i} sx={{ mb: 2 }}>
              <Typography variant="subtitle2" component="span">
                {entry.date}
                {entry.version ? ` · ${entry.version}` : ''}
                {entry.appId ? ` · ${entry.appId}` : ''}
              </Typography>
              <Typography
                variant="body1"
                sx={entry.critical ? { color: 'error.main', fontWeight: 700 } : undefined}
              >
                {entry.title}
              </Typography>
              {entry.body ? (
                <Typography
                  variant="body2"
                  color={entry.critical ? 'error.main' : 'text.secondary'}
                  sx={{ mt: 0.5, fontWeight: entry.critical ? 700 : undefined }}
                >
                  {entry.body}
                </Typography>
              ) : null}
            </Box>
          ))}
        </Box>
      )}

      <Typography variant="body2" sx={{ mt: 4 }}>
        <Link component={RouterLink} to="/">
          ← Back to dashboard
        </Link>
      </Typography>
    </Container>
  );
};

export default ChangelogPage;
